import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { ClothesTester } from './views/ClothesTester';

const LayoutComponent = () => <ClothesTester />;

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.ClothesTester)
	.setHudVisible(true)
	.build();

export default Layout;
